

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { VisibilitaRequestDTO } from "../dto/visibilita-requestDTO";
import { VisibilitaRequestVO } from "../vo/visibilita-requestVO";
import { TipoVisibilitaEnum } from "../enum/tipo-visibilita-enum";
import { ModificaVisibilitaRequestDTO } from "../dto/modifica-visibilita-requestDTO";
import { ModificaVisibilitaRequestVO } from "../vo/modifica-visibilita-requestVO";
import { MapperVisibilitaRequest } from "./mapper-visibilita-request";




@Injectable({
    providedIn: 'root'
})
export class MapperModificaVisibilitaRequest implements MapperInterface<ModificaVisibilitaRequestDTO, ModificaVisibilitaRequestVO> {
    constructor(
        private mapperVisibilitaRequest: MapperVisibilitaRequest
    ) {

    }
    convertVoToDto(vo: ModificaVisibilitaRequestVO): ModificaVisibilitaRequestDTO {
        if (vo != null) {
            const dto = new ModificaVisibilitaRequestDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.aggiunte = this.mapperVisibilitaRequest.convertListVoToDto(vo.aggiunte);
            dto.rimozioni = this.mapperVisibilitaRequest.convertListVoToDto(vo.rimozioni);

            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: ModificaVisibilitaRequestDTO): ModificaVisibilitaRequestVO {
        if (dto != null) {
            const vo = new ModificaVisibilitaRequestVO();

            vo.aggiunte = this.mapperVisibilitaRequest.convertListDtoToVo(dto.aggiunte);
            vo.rimozioni = this.mapperVisibilitaRequest.convertListDtoToVo(dto.rimozioni);
            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: ModificaVisibilitaRequestVO[]): ModificaVisibilitaRequestDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: ModificaVisibilitaRequestDTO[]): ModificaVisibilitaRequestVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
